import React, { useState } from 'react'
import Grid from '@material-ui/core/Grid'
import { SERVICE_LINES } from '../../../../shared/constants/serviceLines'
import { Header, FieldLabel, FieldText } from '../_local/styles'
import Pencil from '@material-ui/icons/Edit'
import ServiceLineDialog from '../_local/modals/ServiceLineDialog'
import { Box, Button } from '@material-ui/core'

const ServiceLineRow = (props) => {
  const { legacyMetadata, id, legacyFreelancerId, setPropChange } = props
  const [open, setOpen] = useState(false)

  const { primaryServiceLine } = legacyMetadata

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }
  const serviceLine = SERVICE_LINES.find((item) => item.name === primaryServiceLine)

  return (
    <>
      <Grid container justify="space-between" alignItems="center">
        <Grid item>
          <Header>Primary Role</Header>
        </Grid>
        <Grid item>
          <Button onClick={handleClickOpen} startIcon={<Pencil />} color="primary">
            Edit
          </Button>
        </Grid>
      </Grid>

      <Box style={{ width: '75%' }}>
        <Grid container spacing={5}>
          <Grid item>
            <FieldLabel>{serviceLine?.label}</FieldLabel>
            <FieldText>{serviceLine?.text}</FieldText>
          </Grid>
        </Grid>
      </Box>
      <ServiceLineDialog
        open={open}
        handleClose={handleClose}
        setPropChange={setPropChange}
        data={{ serviceLine: primaryServiceLine, expertId: id, legacyFreelancerId }}
      />
    </>
  )
}

export default ServiceLineRow
